<template>
  <ViewLayout v-if="practice">
    <template #item-display>
      <div class="practice-title-wrapper d-flex align-items-center justify-content-between mb-5">
        <h2 class="text-left">Practice: {{ practice.name }}</h2>
        <div class="action-buttons d-flex justify-content-end">
          <div class="text-left">
            <CallToActionButton @buttonClick="
              isPracticeActive = !isPracticeActive;
            activatePopup = !activatePopup;
            " :class="[{ red: isPracticeButtonActive }, { green: !isPracticeButtonActive }]">
              <ConfirmationDialogue cancellationText="Cancel"
                                    :confirmationText="isPracticeActive ? 'Activate' : 'Deactivate'"
                                    @success="handlePracticeState"
                                    @canceled="resetPracticeState" v-model:popup="activatePopup">
                <template #title>
                  {{ isPracticeActive ? "Activate" : "Deactivate" }}
                  Practice??
                </template>
                <template #subtitle>Are you sure you want to
                  {{ isPracticeActive ? "activate" : "deactivate" }} this
                  practice??
                </template>
              </ConfirmationDialogue>
              {{ this.isPracticeButtonActive ? "Deactivate" : "Activate" }}
            </CallToActionButton>

            <small class="error-message ml-2">{{
                activateDeactivateError
              }}</small>
          </div>
          <div class="text-left">
            <CallToActionButton>
              <PatientsImport v-model:isOpen="importPatientsPopup" :practiceId="fullPractice.id"
                              @error="handleImportError"
                              @success="handleImportSuccess">
              </PatientsImport>
              Import Patients
            </CallToActionButton>
          </div>
        </div>
      </div>
      <div class="practice-title-wrapper d-flex align-items-center justify-content-between mb-5">
        <h2 class="text-left">CRM: {{ practice.name }}</h2>
        <div class="action-buttons d-flex justify-content-end">
          <div class="text-left">
            <CallToActionButton @buttonClick="
              isCrmActive = !isCrmActive;
            activateCrmPopup = !activateCrmPopup;
            " :class="[{ red: isCrmButtonActive }, { green: !isCrmButtonActive }]">
              <ConfirmationDialogue cancellationText="Cancel"
                                    :confirmationText="isCrmActive ? 'Activate' : 'Deactivate'"
                                    @success="handleCrmState"
                                    v-model:popup="activateCrmPopup">
                <template #title>
                  {{ isCrmActive ? "Activate" : "Deactivate" }}
                  CRM??
                </template>
                <template #subtitle>Are you sure you want to
                  {{ isCrmActive ? "activate" : "deactivate" }}
                  CRM??
                </template>
              </ConfirmationDialogue>
              {{ isCrmButtonActive ? "Deactivate" : "Activate" }}
            </CallToActionButton>

            <small class="error-message ml-2">{{
                activateDeactivateError
              }}</small>
          </div>
        </div>
      </div>
      <div class="practice-title-wrapper d-flex align-items-center justify-content-between mb-5">
        <h2 class="text-left">New Agenda: {{ practice.name }}</h2>
        <div class="action-buttons d-flex justify-content-end">
          <div class="text-left">
            <CallToActionButton @buttonClick="
              isNewAgendaActive = !isNewAgendaActive;
              activateNewAgendaPopup = !activateNewAgendaPopup;
            " :class="[{ red: isNewAgendaButtonActive }, { green: !isNewAgendaButtonActive }]">
              <ConfirmationDialogue cancellationText="Cancel"
                                    :confirmationText="isNewAgendaActive ? 'Activate' : 'Deactivate'"
                                    @success="handleNewAgendaState"
                                    v-model:popup="activateNewAgendaPopup">
                <template #title>
                  {{ isNewAgendaActive ? "Activate" : "Deactivate" }}
                  New Agenda??
                </template>
                <template #subtitle>Are you sure you want to
                  {{ isNewAgendaActive ? "activate" : "deactivate" }}
                  New Agenda??
                </template>
              </ConfirmationDialogue>
              {{ isNewAgendaButtonActive ? "Deactivate" : "Activate" }}
            </CallToActionButton>

            <small class="error-message ml-2">{{
                activateDeactivateError
              }}</small>
          </div>
        </div>
      </div>
      <div class="practice-title-wrapper d-flex align-items-center justify-content-between mb-5">
        <h2 class="text-left">SMS Reminders: {{ practice.name }}</h2>
        <div class="action-buttons d-flex justify-content-end">
          <div class="text-left">
            <CallToActionButton @buttonClick="handleUpcomingSmsPopup = !handleUpcomingSmsPopup">
              <ConfirmationDialogue
                  cancellationText="Cancel"
                  confirmationText="Confirm"
                  @success="runHandleUpcomingSmsReminders"
                  v-model:popup="handleUpcomingSmsPopup"
              >
                <template #title>
                  Handle Upcoming SMS Reminders?
                </template>
                <template #subtitle>
                  Are you sure you want to process upcoming SMS reminders for this practice?
                </template>
              </ConfirmationDialogue>
              Handle SMS Reminders
            </CallToActionButton>
            <v-dialog
                persistent
                class="sms-results-dialog"
                v-model="showSmsResultsDialog"
                max-width="600px"
            >
              <v-card class="pa-5 card-container">
                <div class="d-flex justify-content-between align-items-center mb-4">
                  <h2>SMS Reminder Processing Results</h2>
                  <v-btn icon @click="showSmsResultsDialog = false" small>
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </div>

                <v-card-text>
                  <div v-if="smsReminderResults">
                    <div v-if="smsReminderResults.successful && smsReminderResults.successful.length > 0" class="mb-4">
                      <h3 class="success-header mb-2">Successfully Processed ({{
                          smsReminderResults.successful.length
                        }})</h3>
                      <ul class="results-list">
                        <li v-for="item in smsReminderResults.successful" :key="item.appointment_id"
                            class="result-item">
                          <strong>Appointment ID: {{ item.appointment_id }}</strong>
                          <ul>
                            <li>Created: {{ item.details.created_count }}</li>
                            <li>Canceled: {{ item.details.canceled_count }}</li>
                            <li>Net Created: {{ item.details.net_created }}</li>
                            <li>Net Canceled: {{ item.details.net_canceled }}</li>
                          </ul>
                        </li>
                      </ul>
                    </div>

                    <div v-if="smsReminderResults.failed && smsReminderResults.failed.length > 0">
                      <h3 class="error-header mb-2">Failed to Process ({{ smsReminderResults.failed.length }})</h3>
                      <ul class="results-list">
                        <li v-for="item in smsReminderResults.failed" :key="item.appointment_id"
                            class="result-item error-item">
                          <strong>Appointment ID: {{ item.appointment_id }}</strong>
                          <p class="error-message-text mt-1">Error: {{ item.error }}</p>
                        </li>
                      </ul>
                    </div>

                    <div v-if="!smsReminderResults.successful.length && !smsReminderResults.failed.length"
                         class="text-center">
                      <p>No SMS reminders were found or processed for this practice.</p>
                    </div>
                  </div>
                  <div v-else>
                    <p>No results to display.</p>
                  </div>
                </v-card-text>

                <div class="d-flex justify-content-end pt-3">
                  <CallToActionButton @buttonClick="showSmsResultsDialog = false">
                    Close
                  </CallToActionButton>
                </div>
              </v-card>
            </v-dialog>
          </div>
        </div>
      </div>

      <ItemInfo :item="practice"/>
    </template>
    <template #lists>
      <ListLayout>
        <template #header>
          <h2>Users</h2>
        </template>
        <template #list>
          <DataTable v-if="workers.info.length > 0" :items="workers.info" :titles="workers.keys"/>
          <TableEmptyState message="There are no Users yet in this practice" v-else/>
        </template>
      </ListLayout>

      <ListLayout class="mt-5">
        <template #header>
          <h2>Rooms</h2>
        </template>
        <template #list>
          <DataTable class="w-100" v-if="rooms.info.length > 0" :items="rooms.info" :titles="rooms.keys"/>
          <TableEmptyState message="There are no Rooms yet in this practice" v-else/>
        </template>
      </ListLayout>
    </template>
  </ViewLayout>
  <PracticeSubscriptionDisplay v-if="fullPractice" :subscription="subscription" :practiceId="fullPractice.id"
                               @subscriptionChanged="subscriptionChanged"></PracticeSubscriptionDisplay>
  <PracticeAddons v-if="fullPractice" :practiceId="fullPractice.id" class="mt-5"></PracticeAddons>
  <PracticeSms v-if="fullPractice" :practiceId="fullPractice.id" class="mt-5"></PracticeSms>
  
  
  <!-- Import Results Dialog -->
  <v-dialog
      persistent
      class="import-results-dialog"
      v-model="showImportResultsDialog"
      max-width="600px"
  >
    <v-card class="pa-5 card-container">
      <div class="d-flex justify-content-between align-items-center mb-4">
        <h2>Patient Import Results</h2>
        <button @click="showImportResultsDialog = false" class="close-button">×</button>
      </div>

      <v-card-text>
        <div v-if="importResults.success" class="text-center">
          <v-icon color="green" size="60" class="mb-3">mdi-check-circle</v-icon>
          <h3 class="success-header mb-2">Import Successful!</h3>
          <p>Successfully imported {{ importResults.count }} patient{{ importResults.count !== 1 ? 's' : '' }}.</p>
        </div>
        <div v-else class="text-center">
          <v-icon color="red" size="60" class="mb-3">mdi-alert-circle</v-icon>
          <h3 class="error-header mb-2">Import Failed</h3>
          <p class="error-message-text">{{ importResults.message }}</p>
        </div>
      </v-card-text>

      <div class="d-flex justify-content-end pt-3">
        <CallToActionButton @buttonClick="showImportResultsDialog = false">
          Close
        </CallToActionButton>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import {
  activateCrm,
  activateNewAgenda,
  activatePractice,
  deactivateCrm,
  deactivateNewAgenda,
  deactivatePractice,
  getPracticeById,
  handleUpcomingSmsReminders
} from "@/api/practices/practicesApi.js";
import PatientsImport from "@/components/PatientsImport";
import PracticeSubscriptionDisplay from "@/components/subscription/PracticeSubscriptionDisplay";

export default {
  name: "SinglePractice",
  components: {
    PatientsImport,
    PracticeSubscriptionDisplay,
  },
  data() {
    return {
      fullPractice: null,
      subscription: null,
      practice: null,
      workers: {
        keys: [
          {first_name: "First Name"},
          {last_name: "Last Name"},
          {email: "Email"},
          {is_active: "Is Active"},
          {is_assistant: "Is Assitant"},
          {phone_number: "Phone Number"},
          {last_active: "Last Active"}
        ],
        info: [],
      },
      rooms: {
        keys: [
          {id: "Room Id"},
          {title: "Room Name"},
          {description: "Description"},
        ],
        info: [],
      },
      isPracticeButtonActive: false,
      isPracticeActive: false,
      isCrmButtonActive: false,
      isCrmActive: false,
      isNewAgendaButtonActive: false,
      isNewAgendaActive: false,
      activatePopup: false,
      activateCrmPopup: false,
      activateNewAgendaPopup: false,
      importPatientsPopup: false,
      activateDeactivateError: null,
      importPatientsError: null,
      handleUpcomingSmsPopup: false,
      showSmsResultsDialog: false,
      smsReminderResults: {successful: [], failed: []},
      showImportResultsDialog: false,
      importResults: {
        success: false,
        message: "",
        count: 0,
      },
    };
  },

  async created() {
    this.fullPractice = await getPracticeById(this.$route.params.id);
    this.isCrmActive = this.fullPractice.config?.isCrmActive ? true : false;
    this.isCrmButtonActive = this.isCrmActive
    this.isNewAgendaActive = this.fullPractice.is_new_agenda_active ? true : false;
    this.isNewAgendaButtonActive = this.isNewAgendaActive;
    this.subscription = this.fullPractice.subscription;
    this.isPracticeActive = this.fullPractice.is_active ? true : false;
    this.isPracticeButtonActive = this.isPracticeActive
    this.practice = this.setPracticeInfo();
    this.workers.info = this.fullPractice.workers;
    this.rooms.info = this.fullPractice.rooms;
  },

  methods: {
    setPracticeInfo() {
      return {
        ID: this.fullPractice.id,
        Owner: `${this.fullPractice.owner.first_name} ${this.fullPractice.owner.last_name}`,
        Name: this.fullPractice.name,
        Email: this.fullPractice.email,
        Country: this.fullPractice.country,
        "Phone number": this.fullPractice.phone_number,
        "Default currency": this.getPracticeCurrency(),
        "Last Active": this.fullPractice.last_active
      };
    },

    getPracticeCurrency() {
      if (this.fullPractice.currency_settings) {
        for (const currencySetting of this.fullPractice.currency_settings) {
          if (currencySetting.default) return currencySetting.name;
        }
      } else {
        return null;
      }
    },

    async handlePracticeState() {
      if (this.isPracticeActive) {
        try {
          this.activateDeactivateError = null;
          const activationResponse = await activatePractice(
              this.fullPractice.id
          );
          this.fullPractice = activationResponse.data;
          this.isPracticeButtonActive = activationResponse.data;
        } catch (error) {
          console.log(error);
          this.activateDeactivateError = "Something went wrong";
        }
      } else {
        try {
          this.activateDeactivateError = null;
          const deactivationResponse = await deactivatePractice(
              this.fullPractice.id
          );
          this.fullPractice = deactivationResponse.data;
          this.isPracticeButtonActive = deactivationResponse.data.is_active;
          console.log(deactivationResponse.data.config)
          this.isCrmButtonActive = deactivationResponse.data.config?.isCrmActive;
        } catch (error) {
          console.log(error);
          this.activateDeactivateError = "Something went wrong";
        }
      }
      this.activatePopup = !this.activatePopup;
    },

    resetPracticeState() {
      this.isPracticeActive = !this.isPracticeActive;
    },

    subscriptionChanged(subscription) {
      this.subscription = subscription;
      this.fullPractice.subscription = subscription;
    },

    async handleCrmState() {
      if (this.isCrmActive) {
        try {
          this.activateDeactivateError = null;
          const activationResponse = await activateCrm(this.fullPractice.id);
          this.fullPractice = activationResponse.data;
          this.isCrmButtonActive = activationResponse.data.config?.isCrmActive
        } catch (error) {
          console.log(error);
          this.activateDeactivateError = "Something went wrong";
        }
      } else {
        try {
          this.activateDeactivateError = null;
          const deactivationResponse = await deactivateCrm(this.fullPractice.id);
          this.fullPractice = deactivationResponse.data;
          this.isCrmButtonActive = deactivationResponse.data.config?.isCrmActive
        } catch (error) {
          console.log(error);
          this.activateDeactivateError = "Something went wrong";
        }
      }
      this.activateCrmPopup = !this.activateCrmPopup;
    },

    async handleNewAgendaState() {
      if (this.isNewAgendaActive) {
        try {
          this.activateDeactivateError = null;
          const activationResponse = await activateNewAgenda(this.fullPractice.id);
          this.fullPractice = activationResponse.data;
          this.isNewAgendaButtonActive = activationResponse.data.is_new_agenda_active
        } catch (error) {
          console.log(error);
          this.activateDeactivateError = "Something went wrong";
        }
      } else {
        try {
          this.activateDeactivateError = null;
          const deactivationResponse = await deactivateNewAgenda(this.fullPractice.id);
          this.fullPractice = deactivationResponse.data;
          this.isNewAgendaButtonActive = deactivationResponse.data.is_new_agenda_active
        } catch (error) {
          console.log(error);
          this.activateDeactivateError = "Something went wrong";
        }
      }
      this.activateNewAgendaPopup = !this.activateNewAgendaPopup;
    },

    async runHandleUpcomingSmsReminders() {
      this.smsReminderResults = {successful: [], failed: []};

      try {
        const response = await handleUpcomingSmsReminders(this.fullPractice.id);

        if (response && Array.isArray(response.data?.successful) && Array.isArray(response.data?.failed)) {
          this.smsReminderResults = response.data;
          this.showSmsResultsDialog = true;
        } else {
          this.smsReminderResults = {
            successful: [],
            failed: [{appointment_id: 'N/A', error: "An unexpected response format was received from the server."}]
          };
          this.showSmsResultsDialog = true;
          console.error("Unexpected SMS reminders response:", response);
        }
      } catch (error) {
        console.error("Error handling SMS reminders:", error);
        let errorMessage = "Failed to handle SMS reminders. Please try again.";
        if (error.response && error.response.data && error.response.data.message) {
          errorMessage = error.response.data.message;
        } else if (error.message) {
          errorMessage = error.message;
        }
        this.smsReminderResults = {successful: [], failed: [{appointment_id: 'N/A', error: errorMessage}]};
        this.showSmsResultsDialog = true;
      } finally {
        this.handleUpcomingSmsPopup = false;
      }
    },

    handleImportSuccess(count) {
      this.importResults = {
        success: true,
        message: "",
        count: count,
      };
      this.showImportResultsDialog = true;
    },

    handleImportError(errorMessage) {
      this.importResults = {
        success: false,
        message: errorMessage,
        count: 0,
      };
      this.showImportResultsDialog = true;
    },
  },
};
</script>

<style scoped>
.practice-title-wrapper .v-input {
  min-width: 150px;
  flex: 0 !important;
}

.clinic-toggle {
  min-width: 100px;
}

.practice-switch {
  width: fit-content;
}

.action-buttons {
  min-width: 25%;
  gap: 30px;
}

.error-message {
  color: var(--danger-color);
}

.success-message {
  color: var(--success-color);
}

.sms-results-dialog {
  display: flex;
  align-items: center;
  justify-content: center;
}

.sms-results-dialog .card-container {
  max-height: 80vh;
  overflow-y: auto;
}

.sms-results-dialog .success-header {
  color: var(--success-color, #4CAF50);
}

.sms-results-dialog .error-header {
  color: var(--danger-color, #f44336);
}

.sms-results-dialog .results-list {
  list-style-type: none;
  padding-left: 0;
}

.sms-results-dialog .result-item {
  background-color: #f9f9f9;
  border: 1px solid #eee;
  border-radius: 5px;
  padding: 10px;
  margin-bottom: 10px;
}

.sms-results-dialog .result-item ul {
  list-style-type: disc;
  padding-left: 20px;
  margin-top: 5px;
}

.sms-results-dialog .error-item {
  background-color: #ffebee;
  border-color: #ef9a9a;
}

.sms-results-dialog .error-message-text {
  color: var(--danger-color, #f44336);
  font-weight: bold;
}

.success-header {
  color: var(--success-color, #4CAF50);
}

.error-header {
  color: var(--danger-color, #f44336);
}

.error-message-text {
  color: var(--danger-color, #f44336);
  font-weight: bold;
}

.close-button {
  background: none;
  border: none;
  font-size: 24px;
  font-weight: bold;
  cursor: pointer;
  padding: 5px;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  color: #666;
}

.close-button:hover {
  background-color: #f0f0f0;
  color: #333;
}

.import-results-dialog {
  display: flex;
  align-items: center;
  justify-content: center;
}

.import-results-dialog .card-container {
  max-height: 80vh;
  overflow-y: auto;
}
</style>
